<template>
    <el-dialog :title="(customerId ? 'Update' : 'Create') + ' ' + $t('common.customer')" :visible.sync="showDialog" @open="loadCustomer" @close="closeDialog" width="60%" :close-on-click-modal="false">
        <el-button @click="createCountry" type="primary" size="mini">
            {{$t('masters.createCountry')}}
        </el-button>
        <el-tabs v-model="activeStep">
            <el-tab-pane :label="$t('masters.customerDetails')" name="generalInfo">
                <el-form v-loading="loading" ref="form" :model="form" :rules="rules" size="small" label-width="140px" label-position="left">
                    <el-form-item label="Chain" prop="chainId">
                        <chain-selector v-model="form.chainId"></chain-selector>
                    </el-form-item>
                    <el-form-item :label="$t('common.number')" prop="no">
                        <el-input v-model="form.no"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.name')" prop="name">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.contactPerson')" prop="contactPersonName">
                        <el-input v-model="form.contactPersonName"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('masters.classification')" prop="classification">
                        <el-radio-group v-model="form.classification">
                            <el-radio label="1">A</el-radio>
                            <el-radio label="2">B</el-radio>
                            <el-radio label="3">C</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="RS" prop="isRs">
                        <el-switch v-model="form.isRs"></el-switch>
                    </el-form-item>
                    <address-selector v-model="form" :showRegional="true"></address-selector>
                    <company-selector v-if="form.selectedCountryState && !customerId" ref="companySelector" v-model="form.empty" :serviceCompany.sync="form.primaryServiceCompanyId" :country="form.selectedCountryState[0]" :state="form.selectedCountryState[1]" :city="form.city" :address="form.address" :zip="form.zip"></company-selector>
                    <company-selector v-if="form.selectedCountryState && customerId" ref="companySelector" v-model="form.info" :serviceCompany.sync="form.primaryServiceCompanyId" :country="form.selectedCountryState[0]" :state="form.selectedCountryState[1]" :city="form.city" :address="form.address" :zip="form.zip"></company-selector>                    <h3>{{$t('masters.contactInfo')}}</h3>
                    <el-form-item :label="$t('common.phone')" prop="phone">
                        <el-input v-model="form.phone" v-mask="'(###) ###-####'"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('common.email')" prop="email">
                        <el-input v-model="form.email"></el-input>
                    </el-form-item>
                </el-form>
                <h3 v-if="customerId">{{$t('common.equipment')}}</h3>
                <el-table v-if="customerId" size="mini" :data="form.registeredEquipment" v-loading="loading" class="orders-table tablewithshading" style="margin-bottom: 15px;">
                    <el-table-column prop="model" :label="$t('common.model')"></el-table-column>
                    <el-table-column prop="serialNumber" :label="$t('reports.serialNumber')"></el-table-column>
                    <el-table-column prop="warrantyStartString" :label="$t('common.warrantyStart')"></el-table-column>
                    <el-table-column prop="warrantyEndString" :label="$t('common.warrantyEnd')"></el-table-column>
                    <el-table-column :label="$t('common.operations')">
                        <template slot-scope="scope">
                            <el-button :disabled="loading" type="text" @click="editEquipment(scope.row.id)">{{$t('common.edit')}}</el-button>
                            <el-button :disabled="loading" type="text" @click="deleteEquipment(scope.row.id)">{{$t('common.delete')}}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <span>
                    <el-button :disabled="loading" type="primary" @click="save" v-if="$isFullAdmin">{{customerId ? 'Update' : 'Create'}}</el-button>
                    <el-button :disabled="loading" @click="closeDialog">{{$t('common.cancel')}}</el-button>
                </span>
            </el-tab-pane>
            <el-tab-pane :label="$t('masters.notifications')" name="notifications">
                <el-scrollbar style="margin: 10px;">
                    <ul class="comment-box">
                        <li v-for="notification in notifications" :key="notification.id">
                            <p>
                                {{notification.message}}
                                <el-button type="text" @click="deleteNotification(notification.id)" size="small" style="float:right; margin: 0 10px;">{{$t('common.delete')}}</el-button>
                                <el-button type="text" @click="editNotification(notification)" size="small" style="float:right; margin: 0 10px;">{{$t('common.edit')}}</el-button>
                            </p>
                        </li>
                    </ul>
                </el-scrollbar>
                <span>
                    {{$t('masters.newNotificationColon')}}
                    <el-input v-model="notificationMessage" type="textarea" style="margin-bottom: 10px;"></el-input>
                    <el-button @click="saveNotification()">{{isEditNotification ? 'Edit Notification' : 'Add Notification'}}</el-button>
                    <el-button v-if="isEditNotification" @click="cancelNotification()">{{$t('common.cancel')}}</el-button>
                </span>
            </el-tab-pane>
            <el-tab-pane :label="$t('masters.cookingParameters')" name="cookinParams">
                <el-scrollbar style="margin: 10px;">
                    <ul class="comment-box">
                        <li v-for="cookingParam in cookingParams" :key="cookingParam.id">
                            <p>
                                {{cookingParam.cookingParam}}
                                <el-button type="text" @click="deleteCookingParam(cookingParam.id)" size="small" style="float:right; margin: 0 10px;">{{$t('common.delete')}}</el-button>
                                <el-button type="text" @click="editCookingParam(cookingParam)" size="small" style="float:right; margin: 0 10px;">{{$t('common.edit')}}</el-button>
                            </p>
                        </li>
                    </ul>
                </el-scrollbar>
                <span>
                    {{$t('masters.newCookingParameterColon')}}
                    <el-input v-model="cookingParam" type="textarea" style="margin-bottom: 10px;"></el-input>
                    <el-button @click="saveCookingParam()">{{isEditCookingParam ? 'Edit CookingParam' : 'Add CookingParam'}}</el-button>
                    <el-button v-if="isEditCookingParam" @click="cancelCookingParam()">{{$t('common.cancel')}}</el-button>
                </span>
            </el-tab-pane>
            <el-tab-pane :label="$t('masters.qrCode')" name="qrCode">
                    <div style="display: flex; justify-content: center;">
                        <img v-if="form.qrCodeImg" :src="form.qrCodeImg" style="width: 200px; margin: 0 auto;" />
                    </div>
                    <div style="display: flex; justify-content: center; margin-top: 10px;">
                        <el-button v-if="form.qrCodeImg" @click="downloadQrCode()">Download QR Code</el-button>
                    </div>
            </el-tab-pane>
        </el-tabs>
    </el-dialog>
</template>

<script>
    import {
        AddressSelector,
        ChainSelector,
        CompanySelector
    } from "@/app/shared/components";
    import api from "../api";
    import { EventBus } from "@/app/event-bus.js";
    export default {
        name: "create-update-customer-dialog",
        components: {
            AddressSelector,
            ChainSelector,
            CompanySelector
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            customerId: {
                required: false
            }
        },
        data() {
            return {
                form: {
                    primaryServiceCompanyId: undefined,
                    chainId: undefined,
                    no: undefined,
                    name: undefined,
                    contactPersonName: undefined,
                    classification: undefined,
                    selectedCountryState: undefined,
                    city: undefined,
                    address: undefined,
                    regional: undefined,
                    region: undefined,
                    zip: undefined,
                    phone: undefined,
                    email: undefined,
                    activeStep: "generalInfo",
                    notificationMessage: "",
                    notificationId: undefined,
                    isEditNotification: false,
                    registeredEquipment: undefined,
                    isRs: false,
                    cookingParam: "",
                    cookingParamId: undefined,
                    isEditCookingParam: false,
                    info: undefined,
                    empty: ""
                },
                rules: {
                    name: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterCustomerName'),
                            trigger: "blur"
                        },
                        {
                            validator: (rule, value, callback) => {
                                var chainHasRule = this.form.chainId && this.form.chainId[1];
                                var chainRule = this.form.chainId
                                    ? this.form.chainId[1]
                                    : undefined;
                                if (chainHasRule) {
                                    if (!chainRule) {
                                        callback(new Error(this.$t('common.pleaseSelectChainFirst')));
                                        return;
                                    }
                                    if (chainRule && !value.startsWith(chainRule)) {
                                        callback(
                                            new Error(this.$t('common.customerNameShouldStartWith') + ` '${chainRule}'`)
                                        );
                                        return;
                                    }
                                }
                                callback();
                            },
                            trigger: "blur"
                        }
                    ],
                    no: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterNumber'),
                            trigger: "blur"
                        }
                    ],
                    classification: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterClassification'),
                            trigger: "change"
                        }
                    ],
                    chainId: [
                        {
                            validator: (rule, value, callback) => {
                                if (!value || value === "") {
                                    callback(new Error(this.$t('masters.plaseSelectChain')));
                                } else {
                                    callback();
                                }
                            },
                            type: "array",
                            required: true,
                            message: this.$t('masters.plaseSelectChain'),
                            trigger: "change"
                        }
                    ],
                    selectedCountryState: [
                        {
                            type: "array",
                            required: true,
                            message: this.$t('common.pleaseEnterProvinceAndCountry'),
                            trigger: "change"
                        }
                    ],
                    city: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterCity'),
                            trigger: "blur"
                        }
                    ],
                    address: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterAddress'),
                            trigger: "blur"
                        }
                    ],
                    zip: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterZip'),
                            trigger: "blur"
                        }
                    ],
                    phone: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterPhone'),
                            trigger: "blur"
                        }
                    ],
                    primaryServiceCompanyId: [
                        {
                            validator: (rule, value, callback) => {
                                if (this.isCanadaOrUsa && this.isEmptyServiceCompany) {
                                    callback(new Error(this.$t('common.pleaseSelectServiceCompany')));
                                } else {
                                    callback();
                                }
                            },
                            type: "number",
                            message: this.$t('common.pleaseSelectServiceCompany'),
                            trigger: "change"
                        }
                    ],
                    email: [
                        {
                            type: "email",
                            message: this.$t('common.pleaseInputCorrectEmailAddress'),
                            trigger: "blur"
                        }
                    ]
                },
                loading: false,
                showDialog: this.visible,
                notifications: undefined,
                activeStep: "generalInfo",
                notificationMessage: "",
                notificationId: undefined,
                isEditNotification: false,
                equipmentDialogVisible: false,
                cookingParams: undefined,
                cookingParam: "",
                cookingParamId: undefined,
                isEditCookingParam: false
            };
        },
        watch: {
            visible: function (val) {
                this.showDialog = val;
            },
            "form.chainId": function (val) {
                if (!this.form.name && val && val[1]) {
                    this.form.name = val[1] + " ";
                }
            }
        },
        computed: {
            isDominican() {
                return (
                    this.form.selectedCountryState &&
                    this.form.selectedCountryState[0] === "29"
                );
            },
            isCanadaOrUsa() {
                return (
                    this.form.selectedCountryState &&
                    (this.form.selectedCountryState[0] === "1" ||
                        this.form.selectedCountryState[0] === "2")
                );
            },
            isEmptyServiceCompany() {
                // primaryServiceCompanyId === 1 is number of empty service company record
                //return this.form.primaryServiceCompanyId === 1 || !this.form.primaryServiceCompanyId || this.form.primaryServiceCompanyId === "";
            }
        },
        methods: {
            loadCustomer() {
                if (this.customerId) {
                    this.loading = true;
                    api.getCustomer(this.customerId).then(response => {
                        this.form = Object.assign({}, response);
                        this.form.previousState = {
                            country: "",
                            state: "",
                            city: "",
                            address: "",
                            zip: "",
                            serviceCompany: "",
                            distance: ""
                        }
                        this.loadNotifications();
                        this.loadCookingParams();
                        this.loading = false;
                    });
                }
            },
            editEquipment(equipmentId) {
                EventBus.$emit("editEquipment", equipmentId);
            },
            deleteEquipment(equipmentId) {
                this.$confirm(this.$t('common.thisWillDeleteEquipmentContinue'), "Warning", {
                    confirmButtonText: "Yes",
                    cancelButtonText: this.$t('common.cancel'),
                    type: "warning"
                })
                    .then(() => {
                        api.deleteEquipment(equipmentId).then(() => {
                            this.loadCustomer();
                            this.$message({
                                type: "success",
                                message: this.$t('common.deleteCompleted')
                            });
                        });
                    })
                    .catch(_ => { });
            },
            closeDialog() {
                this.form.primaryServiceCompanyId = undefined;
                this.loading = false;
                this.showDialog = false;
                this.activeStep = "generalInfo";
                this.notifications = null;
                this.notificationMessage = "";
                this.notificationId = null;
                this.isEditNotification = false;
                this.$refs["form"].resetFields();
                if (this.$refs["companySelector"])
                {
                    this.$refs["companySelector"].cleanFields();
                }
                
                this.$emit("dialogClosed");
            },
            save() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        // Commented because this is only for a specific case and does not solve anything.
                        // The Customer name has to be checked in the Customer Controller!!!!
                        this.form.name = /#/.test(this.form.name) ? (this.form.name.split("#")[0] + "#" + this.form.name.split("#")[1].trim()) : this.form.name;
                        this.loading = true;
                        api
                            .saveCustomer(this.customerId, this.form)
                            .then(response => {
                                if (response != null && response.data != null) {
                                    EventBus.$emit("saveCustomer", response.data.id);
                                }
                                this.closeDialog();
                            })
                            .catch(error => {
                                this.loading = false;
                            });
                    } else {
                        return false;
                    }
                });
            },
            loadNotifications() {
                this.notificationMessage = "";
                this.notificationId = null;
                this.isEditNotification = false;
                api.getNotifications(this.customerId).then(response => {
                    this.notifications = response.data;
                });
            },
            editNotification(notification) {
                this.notificationMessage = notification.message;
                this.notificationId = notification.id;
                this.isEditNotification = true;
            },
            deleteNotification(id) {
                this.$confirm(this.$t('common.thisWillDeleteNotificationContinue'), "Warning", {
                    confirmButtonText: this.$t('common.OK'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: "warning"
                })
                    .then(() => {
                        api.deleteNotification(id).then(() => {
                            this.loadNotifications();
                            this.$message({
                                type: "success",
                                message: this.$t('common.deleteCompleted')
                            });
                        });
                    })
                    .catch(_ => { });
            },
            saveNotification() {
                if (this.isEditNotification) {
                    var notification = this.notifications.find(
                        x => x.id == this.notificationId
                    );

                    var date = new Date().toLocaleDateString() + " - " + this.$currentUser.profile.name + " "; 
                    notification.message = (this.notificationMessage.split(/\d\/\d\/\d\d\d\d - /)[0] ? this.notificationMessage.split(/\d\/\d\/\d\d\d\d - /)[0] : this.notificationMessage) + " " + date;

                    api.saveNotification(this.customerId, notification).then(() =>
                    {
                        this.loadNotifications();
                        this.$notify({
                            title: this.$t('common.success'),
                            message: this.$t('common.notifySuccesfullySaved'),
                            type: "success"
                        });
                    });
                } else
                {
                    var date = new Date().toLocaleDateString() + " - " + this.$currentUser.profile.name + " ";
                    var notification = {
                        message: (this.notificationMessage.split(/\d\/\d\/\d\d\d\d - /)[0] ? this.notificationMessage.split(/\d\/\d\/\d\d\d\d - /)[0] : this.notificationMessage) + " " + date
                    };
                    api.saveNotification(this.customerId, notification).then(() => {
                        this.loadNotifications();
                        this.$notify({
                            title: this.$t('common.success'),
                            message: this.$t('common.notifySuccesfullySaved'),
                            type: "success"
                        });
                    });
                }
            },
            cancelNotification() {
                this.notificationMessage = null;
                this.notificationId = null;
                this.isEditNotification = false;
            },
            createCountry() {
                EventBus.$emit("createCountry");
            },
            loadCookingParams() {
                this.cookingParam = "";
                this.cookingParamId = null;
                this.isEditCookingParam = false;
                api.getCookingParams(this.customerId).then(response => {
                    this.cookingParams = response.data;
                });
            },
            editCookingParam(cookingParam) {
                this.cookingParam = cookingParam.cookingParam;
                this.cookingParamId = cookingParam.id;
                this.isEditCookingParam = true;
            },
            deleteCookingParam(id) {
                this.$confirm(this.$t('common.thisWillDeleteCookingParameterContinue'), "Warning", {
                    confirmButtonText: this.$t('common.OK'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: "warning"
                })
                    .then(() => {
                        api.deleteCookingParam(id).then(() => {
                            this.loadCookingParams();
                            this.$message({
                                type: "success",
                                message: this.$t('common.deleteCompleted')
                            });
                        });
                    })
                    .catch(_ => { });
            },
            saveCookingParam() {
                if (this.isEditCookingParam) {
                    var cookingParam = this.cookingParams.find(
                        x => x.id == this.cookingParamId
                    );
                    cookingParam.cookingParam = this.cookingParam;
                    api.saveCookingParam(this.customerId, cookingParam).then(() => {
                        this.loadCookingParams();
                        this.$notify({
                            title: this.$t('common.success'),
                            message: this.$t('common.cookingParameterSuccesfullySaved'),
                            type: "success"
                        });
                    });
                } else {
                    var cookingParam = {
                        cookingParam: this.cookingParam,
                    };
                    api.saveCookingParam(this.customerId, cookingParam).then(() => {
                        this.loadCookingParams();
                        this.$notify({
                            title: this.$t('common.success'),
                            message: this.$t('common.cookingParameterSuccesfullySaved'),
                            type: "success"
                        });
                    });
                }
            },
            cancelCookingParam() {
                this.cookingParam = null;
                this.cookingParamId = null;
                this.isEditCookingParam = false;
            },
            downloadQrCode() {
                const link = document.createElement('a');
                link.href = this.form.qrCodeImg;
                link.download = 'qr-code.png';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    };
</script>
<style>
    .comment-box {
        list-style: none;
        padding: 0;
        margin-top: 0;
        max-height: 400px;
    }

        .comment-box > > > li {
            margin-bottom: 10px;
        }
</style>



// WEBPACK FOOTER //
// ClientApp/app/masters/customers/components/CreateUpdateCustomerDialog.vue